import { apiClient } from '@/lib/api/api-client'

export interface AddOnProduct {
  id: string
  name: string
  description?: string | null
  type:
    | 'AI_CREDITS'
    | 'STORAGE'
    | 'INTEGRATIONS'
    | 'SUPPORT'
    | 'FEATURES'
    | 'USERS'
  status: 'ACTIVE' | 'INACTIVE' | 'ARCHIVED'
  price: number
  currency: string
  configuration: {
    billing_type?: string
    billing_period?: string
    min_quantity?: number
    max_quantity?: number
    credits?: number
  }
  minPurchaseQty: number
  maxPurchaseQty?: number | null
  metadata?: { savings?: string; features?: string[] }
}

export interface AddOnPurchase {
  id: string
  organizationId: string
  addOnProductId: string
  quantity: number
  status: string
  appliedAt?: string | null
  addOnProduct: AddOnProduct
}

export interface PurchaseRequest {
  requestId: string
  addOnProductId: string
  quantity: number
}

export const addOnsApi = {
  catalog: () => apiClient<AddOnProduct[]>('/addons'),
  purchase: (request: PurchaseRequest) =>
    apiClient<{ purchase: AddOnPurchase; stripeCheckoutUrl?: string }>(
      '/addons/purchase',
      { method: 'POST', body: request },
    ),
  receipt: (id: string) =>
    apiClient<AddOnPurchase>(`/addons/purchases/${encodeURIComponent(id)}`),
  resume: (id: string) =>
    apiClient<{ url: string }>(
      `/addons/purchases/${encodeURIComponent(id)}/checkout`,
      { method: 'POST' },
    ),
  cancelCheckout: (id: string) =>
    apiClient<AddOnPurchase>(
      `/addons/purchases/${encodeURIComponent(id)}/cancel-checkout`,
      { method: 'POST' },
    ),
}
